<template>
    <div class="mergediv" ref="mydiv">

                <label id="warninglabel" class="warninglabel">{{ fillwarning }}</label>
                <div class="rightjustified " id="buttonbox">
                    <!-- noprint -->
                    <input id="savebutton" class="margin10 " type="button" @click="dosave()" value="Save" :disabled="pleaseWait" />
                    <input id="printbutton" class="margin10 " type="button" @click="doprint()" value="Print" :disabled="pleaseWait"/>
                    <input id="closebutton" class="margin10 " type="button" @click="closemeconfirm" value="Close" :disabled="pleaseWait"/>
                 </div>
                 <div id="msgdiv">
                    <label v-if="pleaseWait" class="pleasewait">Saving...Please Wait...</label>
                    <label v-if="responseMessage!=null" class="responsemessage">{{ responseMessage }}</label>
                 </div>
                 <vue-html2pdf
                    :show-layout="true"
                    :float-layout="false"
                    :enable-download="false"
                    :preview-modal="false"
                    :paginate-elements-by-height="1200"
                    filename="dynamic-report"
                    :pdf-quality="2"
                    :manual-pagination="true"
                    pdf-format="a4"
                    pdf-orientation="portrait"
                    pdf-content-width="800px"
                    @progress="onProgress($event)"
                    @startPagination="startPaginationHandler()"
                    @hasPaginated="hasPaginatedHandler()"
                    @beforeDownload="beforeDownloadHandler($event)"
                    @hasDownloaded="hasDownloadedHandler($event)"
                    ref="html2Pdf"
                    > 
                    <section slot="pdf-content" class="pdf-content">
                        
                            <div class="docclass">
                                <div v-for="item in document.items" :key="item.id" :value="item.id" :class="divclass(item)">
                                    <div v-if="item.enter=='pagebreak'" class="page-break"/>
                                    <!-- class="html2pdf__page-break" -->

                                    <!-- yesno start-->
                                    <label v-if="item.enter=='ynstart'">YES</label>
                                    <input v-if="item.enter=='ynstart'" type="checkbox"  class="checkclass"/>
                                    <label v-if="item.enter=='ynstart'"for="">NO</label>
                                    <input  v-if="item.enter=='ynstart'" type="checkbox" class="checkclass" @input="isDirty=true"/>

                                    <!-- checkstart -->
                                    <input v-if="item.enter=='checkstart'" type="checkbox"  class="checkclass" @input="isDirty=true"/>

                                    <label  v-if="item.text!=null   && item.enter!=''" :class="labelclass(item)">{{ item.text }}</label>
                                    <div v-html="item.text" v-if="item.text!=null  && item.enter==''" :class="labelclass(item)"></div>


                                    <!-- input -->
                                    <input v-if="item.enter=='wide'" class="inputclass" @input="isDirty=true"/>
                                    <input v-if="item.enter=='narrow'" class="inputclassnarrow" @input="isDirty=true"/>
                                    <input v-if="item.enter=='extrawide'" class="inputclassextrawide" @input="isDirty=true"/>
                                
                                    <!-- yesno -->
                                    <label v-if="item.enter=='yn'" @change="isDirty=true">YES</label>
                                    <input v-if="item.enter=='yn'" type="checkbox"  class="checkclass" @input="isDirty=true"/>
                                    <label v-if="item.enter=='yn'"for="">NO</label>
                                    <input  v-if="item.enter=='yn'" type="checkbox" class="checkclass" @input="isDirty=true"/>
                                    
                                    <!-- signature @done="donesign"-->
                                    <signaturepadlight  :enteredName="enteredName" :docName="documentName" v-if="item.enter=='signature'" :sigid="getsigid(item)"/> 


                                    <!-- <br v-if="item.text==null"> -->
                                    <div v-if="item.table" >
                                        <div class="horizFlex">
                                            <div v-for="header in item.headerlist" :key="header.id" :value="header.id" :class="divclass_table(header)">
                                                <label  v-if="header.text!=null" >{{ header.text }}</label>
                                            </div>
                                        </div>
                                        
                                        <div v-for="row in item.rowlist" :key="row.id" :value="row.id" class="">
                                            <div class="horizFlex">
                                                <div v-for="rowitem in row.rowItemList" :key="rowitem.id" :value="rowitem.id" :class="divclass_table(rowitem)">
                                                    <div v-html="rowitem.text"  v-if="rowitem.text!=null" class="htmllabel"></div>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                       
                    </section>
                </vue-html2pdf>    

                <confirm ref="confirmClose" :showLink="falseParam" :showImageButton="falseParam" body='Do you want to close without saving this document to file?' title="Close" @yes="closeme"/> 
                <confirm ref="confirmDeactivate" :showLink="falseParam" :showImageButton="falseParam" body='You already have a document of this type. Do you want to replace the previous copy of the document?' title="Save" @yes="saveanddeactivateDocument()"  /> 
    </div>
</template>
    
<script>
import datamethods from '../../datamethods.js'
import linkbutton from '../controls/linkbutton.vue'
import smallbutton from '../controls/button.vue'
import signaturepadlight from '../controls/signaturelight.vue'
import VueHtml2pdf from "vue-html2pdf"
import confirm from '../actions/confirm.vue'
    export default {
        name:'popandfill',
        components:{
            signaturepadlight,
          linkbutton,
          smallbutton,
          VueHtml2pdf,
          confirm
          
        },
        props:{
            
            
        },
        mixins:[datamethods],
        data(){
            return{
                fillwarning:'Be sure to complete the entire document before saving. Otherwise, you will need to start over to complete it.',
                falseParam:false,
                pleaseWait:false,
                responseMessage:null,

                isDirty:false,
                isSubmitted:false,
                docToDeactivate:0,

                tmppdf:null,
                tmp1:null,

                document:{
                    items:[]
                },
                personId:0,
                documentId:0,
                documentRecord:{} //the full doc record
                 /* document:{
                    items:[
                        {
                            id:1,
                            text:'Affordable CDL Training School',
                            size:'xx-large',
                            alignment:'center',
                            bold:false

                        },
                        {
                            id:2,
                            text:'532A New London Rd',
                            size:'xx-large',
                            alignment:'center',
                            bold:false

                        },
                        {
                            id:6,
                            text:'Admission Requirements:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintoplarge:true

                        },
                        {
                            id:7,
                            text:'Affordable CDL Training School requires that all students at the time of enrollment be at least 18 yrs. of',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                        {
                            id:7,
                            text:'age. The student, must  have a current and valid State of Ct. Driver license. It is the student ',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                        {
                            id:7,
                            text:'responsibility to confirm eligibility with The State of Ct. Motor Vehicle Dept.  Prior to enrollment. ',
                            size:'medium',
                            alignment:'left',
                            bold:false

                        },
                       
                        {
                            id:8,
                            text:'Personal Information:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                        {
                            id:8,
                            text:'Name: Joe Schmortz',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                      
                        {
                            id:8,
                            text:'Driving Record:',
                            size:'x-large',
                            alignment:'left',
                            bold:true,
                            margintop:true

                        },
                        {
                            id:8,
                            text:'Ct. Driver License Number: ',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            enter:'wide',
                            margintop:true
                            

                        },
                        {
                            id:8,
                            text:'Have you ever been convicted of a criminal offence? ',
                            size:'medium',
                            alignment:'left',
                            bold:true,
                            enter:'yn'
                            

                        },
                        {
                            id:9,
                            table:true,
                            headerlist:[
                                {
                                    id:1,
                                    text:'Course',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-large',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Tuition Cost',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Book Fees (Textbook-refundable)',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'I-Class Hours',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'Lab Hours',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-small',
                                    margintop:true
                                },
                                {
                                    id:1,
                                    text:'In-Class Time/Schedule',
                                    size:'small',
                                    alignment:'left',
                                    bold:true,
                                    width:'width-large',
                                    margintop:true
                                }
                            ],
                            rowlist:[
                                {
                                    rowitemlist:[
                                        {
                                            id:1,
                                            text:'CDL Tractor Trailer Training Class A Evening (Total Program hours 140 Min.)',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        },
                                        {
                                            id:1,
                                            text:'$4,600.00*',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'$55.00',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'In-Class 40 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'100 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'<b>Evening Schedule</b><br>(In Class/Lab Evening Schedule) 5:30-8:30 PM M/W/TH 8:30 AM-5PM Sat/Sun<br><b>Day Schedule</b><br>M-F 8:00am-4:30pm <br><b>By Appointment</b>',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        }
                                    ]
                                },
                                {
                                    rowitemlist:[
                                        {
                                            id:1,
                                            text:'CDL Tractor Trailer Training Class A Evening (Total Program hours 140 Min.)',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        },
                                        {
                                            id:1,
                                            text:'$4,600.00*',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'$55.00',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'In-Class 40 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'100 hr',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-small'
                                        },
                                        {
                                            id:1,
                                            text:'<b>Evening Schedule</b><br>(In Class/Lab Evening Schedule) 5:30-8:30 PM M/W/TH 8:30 AM-5PM Sat/Sun<br><b>Day Schedule</b><br>M-F 8:00am-4:30pm <br><b>By Appointment</b>',
                                            size:'small',
                                            alignment:'left',
                                            bold:false,
                                            width:'width-large'
                                        }
                                    ]
                                }
                                    
                                    
                                
                            ]
                        },
                        {
                            id:8,
                            text:'I (initial) _______ understand by signing my name that I acknowledge I have read and understand this',
                            size:'small',
                            alignment:'left',
                            bold:false,
                            margintop:true

                        },
                  
                        {
                            id:8,
                            text:'Student Signature: ______________________________________   Date: _________________',
                            size:'small',
                            alignment:'left',
                            bold:false,
                            margintop:true

                        },

                    ]
                 } */
                    
            }
        },
        computed:{
            
          
        },
        methods:{
            getsigid(item){
                return "sig" + item.id
            },
            async onProgress(){

            },
            async hasPaginatedHandler(){

            },
            async startPaginationHandler(){

            },
            async hasDownloadedHandler(){

            },
            async beforeDownloadHandler({html2pdf,options,pdfContent}){
                var mythis = this
                const html2PdfSetup = html2pdf().set(options).from(pdfContent)
                let pdfBlobUrl = null

                pdfBlobUrl = await html2PdfSetup.save().output('bloburl')

                if (pdfBlobUrl) {
                    const res = await fetch(pdfBlobUrl)
                    const blobFile = await res.blob()
                    //this.$emit('hasDownloaded', blobFile)
                    this.savedoc_blob(blobFile,"test.pdf")
                }
            
                
            },
            /* doc.canReplace_Admin && doc.fileDisplayName!=null){
                    this.docIdToDeactivate=doc.id   */ 
            saveanddeactivateDocument(){
                this.pleaseWait=true
                this.docToDeactivate=this.documentRecord.id
                console.log('generate after saveanddeact')
                this.$refs.html2Pdf.generatePdf();
            },

            makePDF(){
                this.pleaseWait=true
                console.log('generate in makepdf from dosave')
                this.$refs.html2Pdf.generatePdf();
            },
            dosave(){
                if(this.documentRecord.canReplace_Admin && this.documentRecord.fileDisplayName!=null){
                    //ask if they want to replace
                    this.docToDeactivate=0
                    this.$refs.confirmDeactivate.Show()

                }
                else{
                    this.makePDF()
                }
                
            },
            doprint(){
                var mythis = this
                //document.getElementById('printbutton').style.visibility = 'collapse';
                //document.getElementById('closebutton').style.visibility = 'collapse';
                //document.getElementById('savebutton').style.visibility = 'collapse';
                //document.getElementById('warninglabel').style.visibility = 'collapse';
                //document.getElementById('buttonbox').style.visibility = 'collapse';
                document.getElementById('warninglabel').style.display = 'none';
                document.getElementById('buttonbox').style.display = 'none';
                document.getElementById('msgdiv').style.display = 'none';
                //generate pdf
                if(this.isDirty ){
                    this.dosave()
                }
                

                
                window.print();
                /* document.getElementById('printbutton').style.visibility = 'visible';
                document.getElementById('closebutton').style.visibility = 'visible';
                document.getElementById('savebutton').style.visibility = 'visible';
                document.getElementById('warninglabel').style.visibility = 'visible';
                document.getElementById('buttonbox').style.visibility = 'visible'; */
                document.getElementById('warninglabel').style.display = 'block';
                document.getElementById('buttonbox').style.display = 'block';
                document.getElementById('msgdiv').style.display = 'block';
            },
            async savedoc_blob(blob, file){
                this.responseMessage = null
                var mythis = this

                var imageblob = blob
                    //var pId=this.record.personId
                    var postParams = new FormData();

                    postParams.append(file,imageblob,file);
                    
                    postParams.append('personId',mythis.personId);
                    postParams.append('typeId',mythis.documentId);

                    var response = await this.callAPI(postParams,'savedocument_merge')
                    //handle response
                    if(response.Successful){
                        //if we have a doc to deactivate then ask, else get docs
                        if(this.docToDeactivate>0){
                            this.deactivateDocument(this.docToDeactivate)
                        }else{
                            //this.GetDocuments();
                        }
                        //reset flags
                        this.isSubmitted=true
                        this.isDirty=false
                        
                        this.pleaseWait=false
                    }else{
                        this.responseMessage = response.Message
                        this.pleaseWait=false
                    }
             
    
            },
            async deactivateDocument(doc){
                if(doc==0){return}
                let req = {
                    documentId:doc
                }

                var response = await this.callAPI(req,'deactivatedocument')
                //handle response
                if(response.Successful){
                  //  this.GetDocuments();  
                }else{
                    this.responseMessage = response.Message
                }
                
            },
            
            Start(doc,d,p,documentrec){
                this.document=doc
                this.documentId=d
                this.personId=p
                this.documentRecord = documentrec
                this.responseMessage=null

                
            },
            closemeconfirm(){
                
                if(this.isDirty ){
                    
                    this.$refs.confirmClose.Show()
                }else{this.closeme()}
            },
            closeme(){
               
                this.$emit('close',this.personId)
            },
            divclass(item){
                var cls=''
                
                cls=cls + ' ' + item.alignment
                cls=cls + ' ' + item.size
                if(item.bold){cls=cls + ' bold'}
                if(item.margintoplarge){cls = cls + ' itemmargintoplarge'}
                else if(item.margintop){cls = cls + ' itemmargintop'}
                else{cls = cls + ' item'}
                if(item.width!=undefined){
                    cls = cls + ' ' + item.width
                }
                return cls
            },
            divclass_table(item){
                var cls='bordered'
                
                cls=cls + ' ' + item.alignment
                cls=cls + ' ' + item.size
                if(item.bold){cls=cls + ' bold'}
                if(item.margintoplarge){cls = cls + ' tableitemmargintoplarge'}
                else if(item.margintop){cls = cls + ' tableitemmargintop'}
                else{cls = cls + ' tableitem'}
                if(item.width!=undefined){
                    cls = cls + ' ' + item.width
                }
                return cls
            },
            labelclass(item){
                var cls=""
                if(item.text!=null){cls = cls + 'keepspace'}
                if(item.enter=='wide'){
                    cls = cls + " label-width-medium"
                }
                if (item.enter=='width'){
                    cls = cls + ' htmllabel'
                }
                return cls
            },
            /* hasGenerated(pdfblob){
                mythis.savedoc(pdfblob,'mergeandfill.pdf')
            }, */
            /* async savedoc(dataurl, file){
                var mythis = this

                var imageblob = await fetch(dataurl).then(r=>r.blob())
                    //var pId=this.record.personId
                    var postParams = new FormData();

                    postParams.append(file,imageblob,file);
                    
                    postParams.append('personId',mythis.personId);
                    postParams.append('typeId',mythis.documentId);

                    var response = await this.callAPI(postParams,'savedocument')
                    //handle response
                    if(response.Successful){
                        //if we have a doc to deactivate then ask, else get docs
                        if(this.docIdToDeactivate>0){
                            this.askToDeactivate()
                        }else{
                            this.GetDocuments();
                        }
                        
                    }else{
                        this.responseMessage = response.Message
                    }
             
    
            }, */
        },
        mounted(){
    
          
        },
        
    }
</script>
    
<style scoped>
.page-break {
        page-break-before: always;
    }

    .itemmargintop{
        margin-top:20px;
        padding:0px;
    }
    .itemmargintoplarge{
        margin-top:40px;
        padding:0px;
    }
    .docclass{
        padding:0px;
        
        /* height:72vh; */
    }
  
    .inputclass{
        margin-left:5px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        box-sizing: border-box; 
        font-size: inherit;
         height:26px;
        line-height: 26px;
        /* line-height: 1.5; */
        overflow:visible;
        display: inline-block;
    }
    .inputclassnarrow{
        margin-left:5px;
        width:50px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        box-sizing: border-box; 
        font-size: inherit;
        height:26px;
        line-height: 26px;
        /* line-height: 1.5; */
        overflow:visible;
        display: inline-block;
    }
    .inputclassextrawide{
        margin-left:5px;
        width:500px;
        border: 1px solid #ccc;
        padding: 0px 10px;
        box-sizing: border-box; 
        font-size: inherit;
         height:26px;
        line-height: 26px;
        /* line-height: 1.5; */
        overflow:visible;
        display: inline-block;
    }
    .item{
        margin-top:5px;
        margin-bottom:5px;
        padding:0px;
    }
    .bold{
        font-weight: bold;
    }
    .small{
        font-size:small;
    }
    .medium{
        font-size:medium
    }
    .large{
        font-size:large
    }
    .x-large{
        font-size:x-large
    }
    .xx-large{
        font-size:xx-large
    }
    .center{
        text-align: center;
    }
    .left{
        text-align: left;
    }
    .bordered{
        border:1px solid gray;
        border-radius:0px;

    }
    .horizFlex{
    display:flex;
    flex-direction: row;

  }
  .tableitem{
    padding:5px;
    
  }
  .tableitemmargintop{
        margin-top:20px;
        padding:5px;
    }
    .tableitemmargintoplarge{
        margin-top:40px;
        padding:5px;
    }
  .width-small{
    width:100px;
  }
  .width-medium{
    width:100px;
  }
  .width-large{
    width:200px;
  }
  .width-xlarge{
    width:600px;
  }
  .label-width-medium{
    display: inline-block;
    width:220px;
  }
  .htmllabel{
    white-space: pre-wrap;
  }
  .keepspace{
    white-space: pre;
  }
  .mergediv{
    background-color: white;
    padding:20px;
  }




  .pdf-content {
padding: 30px; /* Adds space around the content */
margin-left: auto;
margin-right: auto;
max-width: 100%; /* Ensure content doesn't overflow */
  }
  
  /* Styling for text with equal margin on both sides */
/*   h1, p {
text-align: justify;
margin-left: 30px;
margin-right: 30px;
line-height: 1.6;
  } */
  
  /* Ensure long content breaks across pages correctly */
  p {
word-wrap: break-word;
  }
  
  /* Styling for the image, making it larger and centering it */
  .image-container {
text-align: center;
margin-top: 20px;
  }
  
  img {
max-width: 80%; /* Makes the image larger */
height: auto;
margin-top: 10px;
  }
  .warninglabel{
    color:red;
    font-size: medium;
  }
</style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    